
<span *ngIf="appliedDiscount" [tooltip]="'.discount-tooltip'" [offsetLeft]="250" [offsetTop]="-10" [maxWidth]="'600px'">
  <span class="discount-badge">
    <img src="assets/icones/{{ getIcon() }}.svg" alt="" />
    {{ appliedDiscount.discount + '%' }}
  </span>
  <div class="tooltip-content">
    <div class="discount-tooltip">
      <div class="discount-container">
        <span class="discount-name">{{ getTitle() }}</span>
        <span class="discount-message" [innerHTML]="getMessage()"></span>
      </div>
    </div>
  </div>
</span>